import { useOrderListDividingStore } from '@/hooks/use-order-list-dividing'
import { SocketEventName } from 'store/src/socket/SocketService'
import { useChangeSymbol } from 'store/src/hooks'
import { HandicapType, useKlineStore, exchangeSocketService } from 'store'
import '../../SpotTrade/styles/handicap-real-time-transaction-body.scss'
import '@/styles/components/table-item.scss'
import '@/styles/components/table-item-cell.scss'

export const HandicapBuy = defineComponent({
  setup() {
    const buyList = ref<SocketResponse.HandicapData[]>([])
    const orderListDividing = useOrderListDividingStore()
    const klineStore = useKlineStore()

    const listenHandicapCallback = (response: SocketResponse.HandicapResponse) => {
      if (klineStore.currentSymbolId !== Number(response.params.p)) return
      const { b } = response.data

      b.sort((a, b) => b[0].subtractStr(a[0]).toNumber())

      let len = arrayLength.value
      if (klineStore.handicapType === HandicapType.Buy) {
        len *= 2
      }

      const newList = b.slice(0, len)

      if (buyList.value.length !== newList.length) {
        buyList.value = newList
      } else {
        buyList.value.forEach((item, index) => {
          item[0] = newList[index][0]
          item[1] = newList[index][1]
        })
      }
    }

    onMounted(() => {
      exchangeSocketService.onMessage<SocketResponse.HandicapResponse>(SocketEventName.Handicap, listenHandicapCallback)
    })

    onBeforeUnmount(() => {
      exchangeSocketService.offMessage<SocketResponse.HandicapResponse>(SocketEventName.Handicap, listenHandicapCallback)
    })
    const arrayLength = computed(() => {
      return orderListDividing.itemCount
    })

    const totalAmount = computed(() => {
      return Math.max(...buyList.value.map((item) => item[1].toNumber())).toString()
    })

    useChangeSymbol(() => {
      buyList.value = Array.from({ length: arrayLength.value || 50 }, () => ['--', '--'])
    })

    const getScaleX = (currentValue: string) => {
      if (!totalAmount.value || !currentValue) {
        return 0
      }

      const w = currentValue.divideStr(totalAmount.value)
      return w
    }

    const formattedList = computed(() =>
      buyList.value.map(([price, vol]) => {
        const scale = getScaleX(vol)
        return {
          price: price !== '--' ? price.formatCommonMoney?.() : '--',
          vol: vol !== '--' ? vol.formatCommonMoney?.() : '--',
          total: price !== '--' && vol !== '--' ? price.multiplyStr(vol).formatThousandAndMillion() : '--',
          scale,
        }
      }),
    )

    return () => (
      <div class={'handicap-real-time-transaction-body'}>
        {formattedList.value.map((item, index) => (
          <div class={'table-body-item-container'}>
            <div class={'table-body-item'} key={index}>
              <span class={'table-body-item-cell up'}>{item.price || '--'}</span>
              <span class={'table-body-item-cell'}>{item.vol || '--'}</span>
              <span class={'table-body-item-cell'}>{item.total || '--'}</span>
            </div>
            <div class={'area up'} style={{ transform: `scaleX(${item.scale})` }}></div>
          </div>
        ))}
      </div>
    )
  },
})
